import React from "react";
import Lottie from "lottie-react";
import carLoader from "../carr.json"; // Place carr.json in src folder

const Preloader = () => {
  return (
    <>
   
    {/* <div className="preloader">
      <div className="preloader-inner">
        <Lottie animationData={carLoader} loop={true} style={{ width: 200, height: 200 }} />
      </div>
    </div> */}
    </>
  );
};

export default Preloader;
